import { render, staticRenderFns } from "./ApprovalPetitionList_new.vue?vue&type=template&id=5dfae48b"
import script from "./ApprovalPetitionList_new.vue?vue&type=script&lang=js"
export * from "./ApprovalPetitionList_new.vue?vue&type=script&lang=js"
import style0 from "./ApprovalPetitionList_new.vue?vue&type=style&index=0&id=5dfae48b&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports